import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ServiceFormGroupModel } from 'src/app/models/form-group.model';
import { ApiService } from 'src/app/services/api.service';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ErrorType } from 'src/app/enums/error-type.enum';
import endpoints from 'src/app/helpers/endpoints';

@Component({
  selector: 'fury-service-add-edit',
  templateUrl: './service-add-edit.component.html',
  styleUrls: ['./service-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class ServiceAddEditComponent implements OnInit, OnDestroy {
  serviceRequestForm!: FormGroup;
  parentlist = [];
  serviceId: string = '';
  ngUnsubscribe = new Subject<void>();
  coverItems = [];
  constructor(
    private api: ApiService,
    private ar: ActivatedRoute,
    private router: Router,
    public location: Location
  ) { }

  ngOnInit(): void {
    this.ar.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => { if (res) { this.serviceId = res['seriveId']; if (this.serviceId) this.getServiceDetail() } })
    this.getParentList(); 
    this.formInIt();
    this.getAllCoverItems();
  }
  formInIt() {
    this.serviceRequestForm = new FormGroup<ServiceFormGroupModel>({
      parent_service_id: new FormControl(''),
      title: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      coveredItemId: new FormControl('', [Validators.required])
    });
  }
  getParentList() {
    this.api.get(`${endpoints.settings.service.getAllServices}?onlyParent=false&page=1&size=9999`).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res: HttpResponse<any>) => {
        if (res.status === 200) {
          if (this.serviceId) { }
          this.parentlist = this.serviceId ? res.body.services.data.filter((ele: any) => ele.serviceId !== this.serviceId) : res.body.services.data
        }
      }
    })
  }
  getServiceDetail() {
    this.api.get(endpoints.settings.service.getServiceDetail(this.serviceId)).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res: HttpResponse<any>) => {
        if (res.status === 200) {
          this.serviceRequestForm.patchValue(res.body.service);
          this.serviceRequestForm.get("coveredItemId").setValue(res.body?.service?.coveredItem?.planCoverItemId);
          if (res.body.service.parentService) {
            this.serviceRequestForm.patchValue({ isParent: 'no', parent_service_id: res.body.service.parentService.serviceId });
          }
        }
      }
    })
  }
  submit() {
    if (this.serviceRequestForm.valid) {
      const data = this.serviceRequestForm.getRawValue();
      delete data.isParent;
      const apiVal = this.serviceId ? this.api.patch(endpoints.settings.service.updateService(this.serviceId), data) : this.api.post(endpoints.settings.service.createService, data)
      apiVal.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.status === 200 || res.status === 201) {
            this.api.alert(res.body.message, 'success');
            this.location.back();
          } else { this.api.alert(res.body.message, 'warning') }
        },
        error: (err: HttpErrorResponse) => { }
      })
    } else { this.serviceRequestForm.markAllAsTouched() }
  }

  getAllCoverItems(){
    this.api.get(`${endpoints.settings.service.getCoverItems}?page=1&size=99999`).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res: HttpResponse<any>) =>{
        this.coverItems = res.body?.planCoverItems?.data;
      },
      error: (err: HttpErrorResponse)=>{
        this.api.alert(err.message, ErrorType.Error);
      }
    })
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
